import type { Channel, WsClient } from '../ws/WsClient'

// React runs passive effects in declaration order. Yielding one microtask lets
// useWsSubscription install every channel before the seed asks WsClient for its
// server ACK. No REST snapshot is accepted before that coverage boundary.
export async function waitForSubscriptionBarrier(
  ws: WsClient | null,
  channels: readonly Channel[],
  signal: AbortSignal
): Promise<void> {
  await Promise.resolve()
  if (signal.aborted) throw new Error('subscription barrier aborted')
  if (ws) await Promise.all(channels.map((channel) => ws.waitForSubscription(channel)))
  if (signal.aborted) throw new Error('subscription barrier aborted')
}
